import { useTranslation } from 'react-i18next'

import {
  AppButton,
  AppDivider,
  AppFlexContainer,
  AppFlexItem,
  AppList,
} from 'client/ui-building-blocks'

import { useGetTopUsers } from 'client/api'
import { UserAvatar } from 'client/components'
import { usePage } from 'client/hooks'

type TRenderItemArgs = {
  _id: string
  username: string
  answeredCount: number
  answeredCorrectCount: number
}

const UsersList = () => {
  const { t } = useTranslation()

  const { navigateTo } = usePage()

  const { data, isLoading, isFetching } = useGetTopUsers('HOME')

  const renderItem = ({ _id, username, answeredCorrectCount }: TRenderItemArgs) => {
    return (
      <AppFlexItem key={_id}>
        <UserAvatar
          userId={_id}
          popupContent={`${username} (${answeredCorrectCount})`}
          profileLink="NAVIGATE"
          rounded
        />
      </AppFlexItem>
    )
  }

  const onMoreUserStatsBtnClick = () => {
    navigateTo({ path: '/best' })
  }

  return (
    <>
      <AppDivider size="large" />
      <AppList
        data={{ count: data?.data.length || 0, data: data?.data || [] }}
        title={t('homePage.topUsers.header')}
        isLoading={isLoading || isFetching}
        isFetching={isFetching}
      >
        <AppFlexContainer justifyContent="center" rowGap="15px" columnGap="15px">
          {data?.data
            .filter(item => item.answeredCorrectCount)
            ?.sort((a, b) => b.answeredCorrectCount - a.answeredCorrectCount)
            .map(renderItem)}
        </AppFlexContainer>
      </AppList>
      {data?.data.length ? (
        <>
          <AppDivider />
          <AppButton
            variant="outlined"
            text="More user stats"
            position="center"
            onClick={onMoreUserStatsBtnClick}
          />
        </>
      ) : null}
    </>
  )
}

export default UsersList
